import React from 'react';

// Jeu d'icônes maison : trait fin monochrome (currentColor), rendu identique
// sur tous les appareils — remplace les emojis hétérogènes des téléphones.
function Svg({ children, taille = 20, ...props }) {
  return (
    <svg viewBox="0 0 24 24" width={taille} height={taille} fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" {...props}>
      {children}
    </svg>
  );
}

export const IcCamera = (p) => (
  <Svg {...p}>
    <path d="M4 8h2.2l1.5-2.2h8.6L17.8 8H20a1.5 1.5 0 0 1 1.5 1.5V18A1.5 1.5 0 0 1 20 19.5H4A1.5 1.5 0 0 1 2.5 18V9.5A1.5 1.5 0 0 1 4 8Z" />
    <circle cx="12" cy="13.4" r="3.4" />
  </Svg>
);

export const IcGalerie = (p) => (
  <Svg {...p}>
    <rect x="3" y="4.5" width="18" height="15" rx="2" />
    <circle cx="8.6" cy="10" r="1.7" />
    <path d="M3.5 17.5 9 12.5l3.6 3.2 3.4-3 4.5 4.3" />
  </Svg>
);

export const IcFichier = (p) => (
  <Svg {...p}>
    <path d="M6 3.5h8L19 8.5V19a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5A1.5 1.5 0 0 1 6.5 3.5Z" />
    <path d="M14 3.5V8.5H19" />
  </Svg>
);

export const IcVoiture = (p) => (
  <Svg {...p}>
    <path d="M4 13.5 5.6 8.7A2 2 0 0 1 7.5 7.3h9a2 2 0 0 1 1.9 1.4L20 13.5" />
    <path d="M3.5 13.5h17a1 1 0 0 1 1 1v2.6a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-2.6a1 1 0 0 1 1-1Z" />
    <circle cx="7.2" cy="18.9" r="1.6" />
    <circle cx="16.8" cy="18.9" r="1.6" />
  </Svg>
);

export const IcRecu = (p) => (
  <Svg {...p}>
    <path d="M6 3.5h12V20.5l-2.4-1.6-2.4 1.6-1.2-.8-1.2.8-2.4-1.6L6 20.5Z" />
    <path d="M9 8h6M9 11.5h6M9 15h3.5" />
  </Svg>
);

export const IcCoche = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="m8.4 12.2 2.5 2.5 4.7-5" />
  </Svg>
);

export const IcLivre = (p) => (
  <Svg {...p}>
    <path d="M5 4.5A1.5 1.5 0 0 1 6.5 3h11A1.5 1.5 0 0 1 19 4.5v15A1.5 1.5 0 0 1 17.5 21h-11A1.5 1.5 0 0 1 5 19.5Z" />
    <path d="M8.5 3v18M12 8h3.5M12 11.5h3.5" />
  </Svg>
);

export const IcReglages = (p) => (
  <Svg {...p}>
    <path d="M4 7.5h9M17 7.5h3M4 16.5h3M11 16.5h9" />
    <circle cx="15" cy="7.5" r="2" />
    <circle cx="9" cy="16.5" r="2" />
  </Svg>
);

export const IcSortie = (p) => (
  <Svg {...p}>
    <path d="M14 4.5H6.5A1.5 1.5 0 0 0 5 6v12a1.5 1.5 0 0 0 1.5 1.5H14" />
    <path d="M10.5 12H21M17.5 8.5 21 12l-3.5 3.5" />
  </Svg>
);

export const IcDossier = (p) => (
  <Svg {...p}>
    <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5h4.6l2 2.5h8.4A1.5 1.5 0 0 1 21 9v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18Z" />
  </Svg>
);

export const IcEclair = (p) => (
  <Svg {...p}>
    <path d="M13 2.5 5.5 13.5h5L10.5 21.5 18.5 10h-5.2Z" />
  </Svg>
);
